import { pdSchema, PrescriptionResponse } from '@ca/common'
import { PdOverrideValues } from '@order/hooks/state/orderState'
import {
  Label,
  ViewField as V,
} from '@screens/vision/prescription/form/components'
import {
  GAP,
  sButtonWrapper,
  sRow,
  WIDTH_SIDE,
} from '@screens/vision/prescription/form/styles'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'

interface Props {
  data: PrescriptionResponse
  pdOverride?: PdOverrideValues
}

export default function Refraction(props: Props) {
  const { t } = useTranslation(['prescription'])
  const {
    r_sph,
    l_sph,
    r_cyl,
    l_cyl,
    r_axis,
    l_axis,
    r_add,
    l_add,
    r_visus,
    l_visus,
    r_pd,
    l_pd,
  } = props.data

  const { pdOverride } = props

  const pdValidation = useMemo(() => {
    const validation = pdSchema.safeParse({ l_pd, r_pd })
    return validation.success
  }, [l_pd, r_pd])

  return (
    <View className="p-8" style={{ gap: GAP }}>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} />
        </View>
        <Label>{t('prescription:sph', 'SPH')}</Label>
        <Label>{t('prescription:cyl', 'CYL')}</Label>
        <Label>{t('prescription:axis', 'AXIS')}</Label>
        <Label>{t('prescription:add', 'ADD')}</Label>
        <Label>{t('prescription:visus', 'VISUS')}</Label>
        <Label>{t('prescription:pd', 'PD')}</Label>
      </View>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} className="text-right">
            {t('prescription:r', 'R')}
          </Label>
        </View>
        <V plus>{r_sph}</V>
        <V>{r_cyl}</V>
        <V fixed={false}>{r_axis}</V>
        <V>{r_add}</V>
        <V>{r_visus}</V>
        <V
          error={!pdValidation}
          disabled={!!pdOverride && pdOverride.r_pd !== r_pd}
        >
          {r_pd}
        </V>
      </View>
      <View className={sRow}>
        <View className={sButtonWrapper}>
          <Label width={WIDTH_SIDE} className="text-right">
            {t('prescription:l', 'L')}
          </Label>
        </View>
        <V plus>{l_sph}</V>
        <V>{l_cyl}</V>
        <V fixed={false}>{l_axis}</V>
        <V>{l_add}</V>
        <V>{l_visus}</V>
        <V
          error={!pdValidation}
          disabled={!!pdOverride && pdOverride.l_pd !== l_pd}
        >
          {l_pd}
        </V>
      </View>
    </View>
  )
}
